export default {
  namespaced: true,
  

  state: () => ({
    number: '56989185130' // Ejemplo de un número de WhatsApp
  }),
  
  getters: {

    getNumber: (state) => {
      return state.number;
    },
    
    getWhatsappLink: (state) => {
      return `https://wa.me/${state.number}`;
    },
  },

};